import aegis from "../../assets/combatants/underground/mid/aegis.png";
import haoriIori from "../../assets/combatants/underground/mid/haori-iori.png";
import hitoyo from "../../assets/combatants/underground/mid/hitoyo.png";
import houtengeki from "../../assets/combatants/underground/mid/houtengeki.png";
import kawa from "../../assets/combatants/underground/mid/kawa.png";
import kaze from "../../assets/combatants/underground/mid/kaze.png";
import kekemotsu from "../../assets/combatants/underground/mid/kekemotsu.png";
import kyu from "../../assets/combatants/underground/mid/kyu.png";
import nedia from "../../assets/combatants/underground/mid/nedia.png";
import reinama from "../../assets/combatants/underground/mid/reinama.png";
import sakura from "../../assets/combatants/underground/mid/sakura.png";
import unasakaRyou from "../../assets/combatants/underground/mid/unasaka-ryou.png";
import yonna from "../../assets/combatants/underground/mid/yonna.png";
import yui from "../../assets/combatants/underground/mid/yui.png";
import yumaomi from "../../assets/combatants/underground/mid/yumaomi.png";

export const OtherMid = {
  Aegis: {
    name: "Aegis",
    description: "A seductive elf athlete, with a love of licking pussy",
    img: aegis,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Elf",
    bodyShape: "busty",
    eyeColor: "green",
    hairColor: "blonde",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    // Pref properties effect 'AI'
    prefAttack: "tongue",
    prefTarget: "vagina",
    uniqueAttackText: "Aegis's long tongue deftly pleasures xxxx's vagina",
    roughPlayLvl: 14, // how responds to domination either -hates or +likes
    // Prowess is capability
    seductionResistance: 25,
    grapplingProwess: 30,
    tongueProwess: 45,
    touchProwess: 25,
    cockProwess: 25,
    vaginaProwess: 38,
    anusProwess: 25,
    // -- resistance is ability to endure pleasure, 1 - 100
    touchResistance: 45,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 10,
    vaginaResistance: 35,
    anusResistance: 10,
    orgasmLimit: 3,
  },
  haoriIori: {
    name: "Haori Iori",
    description: "A rich young noble girl fallen on hard times.",
    img: haoriIori,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "curvy",
    eyeColor: "blue",
    hairColor: "blonde",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 5,
    vaginaSize: 3,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "touch",
    prefTarget: "cock",
    uniqueAttackText:
      "Iori's tender looks aid in her otherwise unspectacular handjob technique",
    roughPlayLvl: -5,
    seductionResistance: 35,
    grapplingProwess: 20,
    tongueProwess: 35,
    touchProwess: 45,
    cockProwess: 25,
    vaginaProwess: 30,
    anusProwess: 20,
    touchResistance: 25,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 15,
    vaginaResistance: 15,
    anusResistance: 30,
    orgasmLimit: 3,
  },
  Hitoyo: {
    name: "Hitoyo",
    description:
      "A sexy fashionista with rep for opening her legs for a model contract",
    img: hitoyo,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "blue",
    hairColor: "brown",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 4,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "vagina",
    prefTarget: "cock",
    uniqueAttackText:
      "Hitoyo's long legs grab hold and push xxxx's hard cock deep in her wet pussy.",
    roughPlayLvl: 20,
    seductionResistance: 45,
    grapplingProwess: 20,
    tongueProwess: 35,
    touchProwess: 25,
    cockProwess: 20,
    vaginaProwess: 45,
    anusProwess: 20,
    // -- resistance is ability to endure pleasure, 1 - 100
    touchResistance: 25,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 10,
    vaginaResistance: 35,
    anusResistance: 40,
    orgasmLimit: 3,
  },
  Houtengeki: {
    name: "Houtengeki",
    description:
      "A voluptuous nurse in training, has a good record for helping erectile issues.",
    img: houtengeki,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "voluptuous",
    eyeColor: "yellow",
    hairColor: "black",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 3,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "touch",
    prefTarget: "cock",
    uniqueAttackText:
      "Houtengeki uses her giant breasts to smother xxxx's cock with tit meat.",
    roughPlayLvl: -5,
    seductionResistance: 25,
    grapplingProwess: 35,
    tongueProwess: 35,
    touchProwess: 45,
    cockProwess: 25,
    vaginaProwess: 35,
    anusProwess: 20,
    touchResistance: 20,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 30,
    orgasmLimit: 3,
  },
  Kawa: {
    name: "Kawa",
    description: "A soft spoken librarian with a kinky side",
    img: kawa,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "toned",
    eyeColor: "brown",
    hairColor: "brown",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "vagina",
    prefTarget: "vagina",
    uniqueAttackText: "Kawa passionatly scissors herself against xxxx's pussy.",
    roughPlayLvl: 12,
    seductionResistance: 20,
    grapplingProwess: 20,
    tongueProwess: 15,
    touchProwess: 25,
    cockProwess: 20,
    vaginaProwess: 38,
    anusProwess: 25,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 10,
    cockResistance: 10,
    vaginaResistance: 35,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  Kaze: {
    name: "Kaze",
    description: "An alluring punk girl addicted to semen.",
    img: kaze,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "shapely",
    eyeColor: "blue",
    hairColor: "purple",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 3,
    anusSize: 3,
    throatSize: 3,
    prefAttack: "anus",
    prefTarget: "cock",
    uniqueAttackText:
      "Kaze buries xxxx's cock deep into her back passage moaning erotically",
    roughPlayLvl: 15,
    seductionResistance: 42,
    grapplingProwess: 20,
    tongueProwess: 35,
    touchProwess: 15,
    cockProwess: 25,
    vaginaProwess: 30,
    anusProwess: 35,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 25,
    vaginaResistance: 15,
    anusResistance: 35,
    orgasmLimit: 3,
  },
  Kekemotsu: {
    name: "Kekemotsu",
    description: "A successul gardener though rarely hired for her skills.",
    img: kekemotsu,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "grey",
    hairColor: "grey",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "anus",
    uniqueAttackText:
      "Kekemotsu buries her face between xxxx's arse cheeks and softly licks with her wet tongue.",
    roughPlayLvl: -20,
    seductionResistance: 15,
    grapplingProwess: 42,
    tongueProwess: 35,
    touchProwess: 25,
    cockProwess: 10,
    vaginaProwess: 15,
    anusProwess: 20,
    touchResistance: 25,
    breastResistance: 20,
    mouthResistance: 30,
    cockResistance: 10,
    vaginaResistance: 35,
    anusResistance: 40,
    orgasmLimit: 3,
  },
  Kyu: {
    name: "Kyu",
    description: "A cheeky goth girl with an alluring gaze.",
    img: kyu,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "toned",
    eyeColor: "grey",
    hairColor: "black",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 3,
    anusSize: 2,
    throatSize: 4,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText:
      "Kyu gropes xxxx's rack expertly, and switches between tweeking her nipples roughly.",
    roughPlayLvl: 20,
    seductionResistance: 25,
    grapplingProwess: 15,
    tongueProwess: 35,
    touchProwess: 35,
    cockProwess: 25,
    vaginaProwess: 35,
    anusProwess: 20,
    touchResistance: 25,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 30,
    orgasmLimit: 3,
  },
  Nedia: {
    name: "Nedia",
    description: "A cute cosplayer with a hidden feisty side.",
    img: nedia,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "blue",
    hairColor: "brown",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "touch",
    uniqueAttackText:
      "Nedia slides her soft pussy over xxxx's thigh, coating it with her fluids.",
    roughPlayLvl: 12,
    seductionResistance: 25,
    grapplingProwess: 25,
    tongueProwess: 15,
    touchProwess: 25,
    cockProwess: 20,
    vaginaProwess: 38,
    anusProwess: 25,
    touchResistance: 35,
    breastResistance: 25,
    mouthResistance: 10,
    cockResistance: 10,
    vaginaResistance: 35,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  Reinama: {
    name: "Reinama",
    description: "A schoolgirl with a bad reputation for good blowjobs.",
    img: reinama,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "youthful",
    eyeColor: "red",
    hairColor: "black",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 3,
    anusSize: 3,
    throatSize: 4,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Reinama unhesitatingly buries xxxx's cock into her throat, gurgling and choking loudly as she deepthroats.",
    roughPlayLvl: 25,
    seductionResistance: 42,
    grapplingProwess: 25,
    tongueProwess: 45,
    touchProwess: 15,
    cockProwess: 25,
    vaginaProwess: 30,
    anusProwess: 35,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 25,
    vaginaResistance: 15,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  Sakura: {
    name: "Sakura",
    description: "A cyberpunk fangirl, she loves teasing.",
    img: sakura,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "blue",
    hairColor: "light brown",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "anus",
    prefTarget: "mouth",
    uniqueAttackText: "Sakura rides xxxx's face with her plump behind.",
    roughPlayLvl: -5,
    seductionResistance: 24,
    grapplingProwess: 34,
    tongueProwess: 32,
    touchProwess: 25,
    cockProwess: 10,
    vaginaProwess: 15,
    anusProwess: 32,
    touchResistance: 22,
    breastResistance: 20,
    mouthResistance: 30,
    cockResistance: 15,
    vaginaResistance: 35,
    anusResistance: 24,
    orgasmLimit: 3,
  },
  unasakaRyou: {
    name: "Unasaka Ryou",
    description: "A sleepy gaming addict, with a eroge addiction.",
    img: unasakaRyou,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "blue",
    hairColor: "brown",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 3,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "vagina",
    uniqueAttackText:
      "Ryou buries her face into xxxx's pussy, and softly teases her flaps.",
    roughPlayLvl: 2,
    seductionResistance: 25,
    grapplingProwess: 35,
    tongueProwess: 35,
    touchProwess: 15,
    cockProwess: 25,
    vaginaProwess: 15,
    anusProwess: 20,
    touchResistance: 25,
    breastResistance: 20,
    mouthResistance: 10,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 22,
    orgasmLimit: 3,
  },
  Yonna: {
    name: "Yonna",
    description: "A ex shygirl, now a wholehearted slut who loves having her chest bukkake'd.",
    img: yonna,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty, petite",
    eyeColor: "grey",
    hairColor: "grey",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 3,
    anusSize: 3,
    throatSize: 4,
    prefAttack: "touch",
    prefTarget: "cock",
    uniqueAttackText:
      "Yonna eagerly trys to milk xxxx's cock for its fresh creamy spunk.",
    roughPlayLvl: 10,
    seductionResistance: 32,
    grapplingProwess: 25,
    tongueProwess: 25,
    touchProwess: 35,
    cockProwess: 25,
    vaginaProwess: 30,
    anusProwess: 35,
    touchResistance: 15,
    breastResistance: 25,
    mouthResistance: 20,
    cockResistance: 25,
    vaginaResistance: 35,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  Yui: {
    name: "Yui",
    description: "A cute gamer girl with a love of breasts.",
    img: yui,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "red",
    hairColor: "pink",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText: "Yui lubes her breasts with spit, then rubs her nipples and tits eagerly against xxxx's rack.",
    roughPlayLvl: -5,
    seductionResistance: 34,
    grapplingProwess: 36,
    tongueProwess: 32,
    touchProwess: 25,
    cockProwess: 10,
    vaginaProwess: 25,
    anusProwess: 32,
    touchResistance: 22,
    breastResistance: 25,
    mouthResistance: 30,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 24,
    orgasmLimit: 3,
  },
  Yumaomi: {
    name: "Yumaomi",
    description: "The local schools resident slut.",
    img: yumaomi,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "soft",
    eyeColor: "blue",
    hairColor: "dirty blonde",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 3,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "breasts",
    uniqueAttackText:
      "Yumaomi slathers xxxx's tits with soft licks and kisses, sucking hungrily on her nipples.",
    roughPlayLvl: 20,
    seductionResistance: 45,
    grapplingProwess: 15,
    tongueProwess: 35,
    touchProwess: 15,
    cockProwess: 25,
    vaginaProwess: 25,
    anusProwess: 20,
    touchResistance: 25,
    breastResistance: 25,
    mouthResistance: 10,
    cockResistance: 35,
    vaginaResistance: 25,
    anusResistance: 22,
    orgasmLimit: 3,
  },
};
